(function () {
  var doc = document;
  var root = doc.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = window.Shopify && window.Shopify.designMode;
  if (reduce || editor || !('IntersectionObserver' in window)) return;

  var KIDS = '.popular-products__item, .lux-collections__item, .lux-trust__item, .lux-stats__item, .lux-story__step';

  function eligible(section, index) {
    if (index === 0) return false;
    if (section.querySelector('[id^="ProductInfo"], .product-section, cart-items, #main-cart-items')) return false;
    var r = section.getBoundingClientRect();
    if (r.bottom < 0) return false;
    if (r.top < window.innerHeight * 0.85) return false;
    return true;
  }

  function prepare() {
    var main = doc.getElementById('MainContent');
    if (!main) return;
    var sections = Array.prototype.slice.call(main.querySelectorAll(':scope > .shopify-section'));
    var targets = sections.filter(eligible);
    if (!targets.length) return;
    root.classList.add('lux-motion');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });

    targets.forEach(function (section) {
      section.classList.add('lux-reveal');
      Array.prototype.forEach.call(section.querySelectorAll(KIDS), function (kid, i) {
        kid.classList.add('lux-kid');
        kid.style.setProperty('--lux-i', String(i % 8));
      });
      io.observe(section);
    });

    // Sicurezza: se qualcosa non scatta, dopo 6 secondi mostra tutto.
    window.setTimeout(function () {
      targets.forEach(function (s) { s.classList.add('is-in'); });
    }, 6000);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', prepare);
  else prepare();
})();
